import React from 'react';

const AsSeenOn = () => {
    return (
        <div className="text-center pb-8">
            <p className="text-xs uppercase tracking-wider text-gray-500 mb-4">As Seen On</p>
            <div className="flex flex-wrap justify-center items-center gap-6">
                <img
                    src="https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65d722cd5e13ee5e7d0734aa_TC.svg"
                    alt="TechCrunch"
                    className="h-6 opacity-60 hover:opacity-80 transition-opacity"
                />
                <img
                    src="https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65d722cd726e2984202298d1_TL.svg"
                    alt="TechLife"
                    className="h-6 opacity-60 hover:opacity-80 transition-opacity"
                />
                <img
                    src="https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65d723488aa426ac4afbb016_TD.svg"
                    alt="TechDaily"
                    className="h-6 opacity-60 hover:opacity-80 transition-opacity"
                />
                <img
                    src="https://cdn.prod.website-files.com/5d53975001f72a80a5fdf1f2/65d722cd9e0cb8d3d7fe3da2_Yahoo.svg"
                    alt="Yahoo"
                    className="h-6 opacity-60 hover:opacity-80 transition-opacity"
                />
            </div>
        </div>
    );
};

export default AsSeenOn; 